import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  driverList: [],
  driverById: {},
  loading : { 
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
  },
  error: false,
  errorMessage: "",
};

const driverSlice = createSlice({
  name: "driverManagement",
  initialState,
  reducers: {
    getDriverList(state, action) {
      state.driverList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    driverByIdData(state, action) {
      state.driverById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getDriverList,
  driverByIdData,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = driverSlice.actions;

export default driverSlice.reducer;
